// Renders a JG submission's advisors grouped by role — a header followed by the list for each of
// Primary, Additional Primary, and Associate. Emails are plain text (no mailto links).
const Group = ({ title, people }) =>
    people.length ? (
        <div className="jg-adv-group">
            <div className="jg-adv-group-title">{title}</div>
            <ul className="jg-advisors">
                {people.map((a, i) => (
                    <li key={i}>
                        {a.name ? <span className="jg-name">{a.name}</span> : null}
                        <span className="jg-email-plain">{a.email}</span>
                        {a.chamberCode ? <span className="jg-adv-code">{a.chamberCode}</span> : null}
                    </li>
                ))}
            </ul>
        </div>
    ) : null;

const JgAdvisorList = ({ advisors }) => {
    const list = advisors || [];
    return (
        <div className="jg-adv-sections">
            <Group title="Primary Advisor" people={list.filter((a) => a.role === 'Primary')} />
            <Group title="Additional Primary Advisors" people={list.filter((a) => a.role === 'Additional Primary')} />
            <Group title="Associate Advisors" people={list.filter((a) => a.role === 'Associate')} />
        </div>
    );
};

export default JgAdvisorList;
